import Router from "./routes/router";
import "./index.css";

export default function App() {
  return (
    <Router />
  );
}
